module.exports = __webpack_public_path__ + "static/img/honorPad5.cb870e33.png";